export default __webpack_public_path__ + "static/logo-secours-catholique-8dcb5e08abadd60b8cc35e8da216ced1.png";